import React from 'react';

export default function BasicFooter() {
  return (
    <footer style={{ textAlign: 'center', backgroundColor: '#fff', padding: 10 }}>
      Copyright © <b>LuongSon TV</b> All rights reserved.
    </footer>
  );
}
